module.exports = __webpack_public_path__ + "static/media/ship.c6e64816.png";